export const modalBoxClassName =
    'bg-giphyBlack border-giphyDarkCharcoal relative flex flex-col rounded-md border-[1px] border-solid'
export const modalBackgroundClassName =
    'bg-giphyBlack z-modal absolute inset-0 flex animate-[fadeIn_150ms_ease-in-out] items-center justify-center bg-opacity-80'
